import { FC } from 'react';

import { MinusOutlined, PlusOutlined } from '@ant-design/icons';

import { Wrapper, IconButton, Value } from './styled';

export type CounterPropsTypes = {
  count: number;
  handleIncrement: () => void;
  handleDecrement: () => void;
  min?: number;
  max?: number;
  disabledDecrement?: boolean;
  disabledIncrement?: boolean;
};

const Counter: FC<CounterPropsTypes> = ({
  count = 0,
  min = 0,
  max = 99,
  handleIncrement = () => false,
  handleDecrement = () => false,
  disabledDecrement = false,
  disabledIncrement = false,
}) => {
  return (
    <Wrapper>
      <IconButton
        disabled={disabledDecrement || count <= min}
        onClick={handleDecrement}
      >
        <MinusOutlined />
      </IconButton>
      <Value>{count}</Value>
      <IconButton
        disabled={disabledIncrement || (max ? count >= max : false)}
        onClick={handleIncrement}
      >
        <PlusOutlined />
      </IconButton>
    </Wrapper>
  );
};

export default Counter;
